import React, { useEffect, useState } from "react";
import { Box, Typography, Paper } from "@mui/material";
import api from "../api/axios";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

export default function ReactionBarChart({ refreshKey }) {
  const [chartData, setChartData] = useState(null);

  const fetchReactions = async () => {
    try {
      const response = await api.get("/dashboard/today_reactions");

      if (response.data.success) {
        setChartData({
          labels: response.data.data.map((r) => r.reaction),
          datasets: [
            {
              data: response.data.data.map((r) => r.count),
              backgroundColor: "#22c55e",
              borderRadius: 6,
              barThickness: 40,
            },
          ],
        });
      }
    } catch (err) {
      console.error("Reaction fetch error:", err);
    }
  };

  /* Fetch on load & refresh */
  useEffect(() => {
    fetchReactions();
  }, [refreshKey]);

  if (!chartData) {
    return <Typography>Loading reactions...</Typography>;
  }

  return (
    <Paper sx={{ p: 3, bgcolor: "background.paper" }}>
      <Typography variant="h6" gutterBottom>
        Today's Mood
      </Typography>

      <Box sx={{ height: 300 }}>
        <Bar
          data={chartData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { display: false } },
            scales: {
              x: { grid: { display: false } },
              y: { beginAtZero: true },
            },
          }}
        />
      </Box>
    </Paper>
  );
}
